import { createAction, props } from '@ngrx/store';
import { State } from './teams.reducer';

export const loadTeams = createAction(
  '[Teams] Load Teams',
);

export const loadTeamsSuccess = createAction(
  '[Teams] Load Teams Success',
  props<{ data: State }>(),
);

export const loadTeamsFailure = createAction(
  '[Teams] Load Teams Failure',
  props<any>(),
);

export const selectTeam = createAction(
  '[Teams] Select Team',
  props<{ slug: string }>(),
);

